import React, { Component } from 'react';
import { Link, browserHistory } from 'react-router';
import DataTable from 'components/data-table';
import { Button } from "@blueprintjs/core";
import { header } from 'constants/table';
import { RowItemDanhSachThongKeGiamSatDonCu } from './datatable';
import { get, isEmpty } from 'lodash';
import { ThongKeBaoCao } from 'api';
import queryString from 'query-string';

class DanhSachThongKeGiamSatDonCu extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tenDonvi: get(this.props, 'params.tenDonVi'),
      tuKhoa: '',
      tableLoading: false,
      search: false,
      danhsachDon: [],
      pageData: {
        number: 0,
        size: 10,
        totalElements: 0
      }
    } 
  }

  componentDidMount() {
    this.getListData();
  }

  getListData() {
    this.setState({
      search: true,
      tableLoading: true
    });
    const parsed = queryString.parse(window.location.search);
    const params = {
      page: this.state.pageData.number,
      size: this.state.pageData.size,
      idDonViHienTai: get(this.props, 'params.idDonVi') || undefined,
      tuKhoa: this.state.tuKhoa.trim() || undefined,
      loaiThongTinDon: get(this.props, 'params.loaiThongTinDon') || undefined,
      phanLoaiDon: parsed.phanLoaiDon || undefined,
      nguonDon: parsed.nguonDon || undefined,
    };
    ThongKeBaoCao.actions.getDanhSachDonCuThongKe.request(params).then(res => {
      if(!isEmpty(res.data)) {
        const data = get(res, 'data._embedded.donCus');
        this.setState({
          danhsachDon: data,
          pageData: get(res, 'data.page')
        });
      } 
    }).finally(() => {
      this.setState({
        search: false,
        tableLoading: false
      });
    });
  }

  handleSearch() {
    this.setState({
      search: true
    }, () => {
      this.getListData();
    });
  }

  onChangeKeyWord(e) {
    this.setState({
      tuKhoa: e.target.value
    });
  }
  
  handleChangePageSize(size) {
    this.setState({
      pageData: {
        ...this.state.pageData,
        size: size,
        number: 0
      }
    }, () => {
      this.getListData();
    });
  }

  handlePageClick(page) {
    this.setState({
      pageData: {
        ...this.state.pageData,
        number: page.selected
      }
    }, () => {
      this.getListData();
    });
  }

  render() {
    return (
      <div className="center reception-container">
        <div className="back-foward mb0">
          <Link onClick={ browserHistory.goBack } title="">Về trang trước</Link>
        </div>
        <div className="top-content">
          <div className="left-content">
            <p className="title-18"><i className="tt tt-theo-doi"></i>
              {`Danh sách Đơn nhập liệu cũ tại ${this.state.tenDonvi}`}
            </p>
          </div>
        </div>
        <div className="bottom-content">
          <div className='wrap-block pl15 pr15 pt20'>
            <div className='row pl10 pr10 pb20 theo-doi'>
              <section className="wrap-block search-container col-80">
                <form className="search-form" action="javascript:void(0)" onSubmit={this.handleSearch.bind(this)}>
                  <input
                    type="text"
                    placeholder="Nhập tên người đứng đơn hoặc số CMND để tìm kiếm..."
                    className="search-input"
                    value={this.state.tuKhoa}
                    onChange={this.onChangeKeyWord.bind(this)}
                    />
                  <Button
                    type="submit"
                    text="Tìm kiếm"
                    className={this.state.tableLoading ? (this.state.searchLoading ? "btn-green tt-search btn-loading" : "btn-green tt-search btn-disable") : "btn-green tt-search"}
                  />
                </form>
              </section>
            </div>
            <div className="row">
              <span className="line-border"></span>
            </div>
          </div>
          <DataTable
            header={header.theoDoi.danhSachThongKeGiamSatDonCu}
            dataList={this.state.danhsachDon}
            pageData={this.state.pageData}
            parent={this}
            hideButtonExport
            search={this.state.search}
            tableLoading={this.state.tableLoading}
          >
            <RowItemDanhSachThongKeGiamSatDonCu />
          </DataTable>
        </div>
      </div>
    )
  }
}

export default DanhSachThongKeGiamSatDonCu


// WEBPACK FOOTER //
// ./src/components/modules/theo-doi-giam-sat/DanhSachThongKeGiamSatDonCu.jsx